import Dat from 'dat.gui'

export class UIControls {
  constructor ({ mounter, last }) {
    if (last) {
      last.destroy()
      if (mounter) {
        mounter.removeChild(last.domElement)
      }
    }

    var gui = new Dat.GUI({ autoPlace: false, close: false })
    mounter.appendChild(gui.domElement)
    let controlList = ['slider', 'selector',  'slider-fg', 'field-knob', 'saturation-field', 'hue-field']
    gui.domElement.addEventListener('touchmove', e => {
      let target = e.touches[0].target
      // console.log(target, target.style)
      if (controlList.some(t => target.classList.contains(t)) || target.style.cssText.indexOf('linear-gradient') !== -1) {
        e.preventDefault()
      }
    }, { passive: false })

    gui.width = mounter.clientWidth
    window.addEventListener('resize', () => {
      gui.width = mounter.clientWidth
    })
    let close = gui.domElement.querySelector('.close-bottom')
    close.style.display = 'none'

    return gui
  }
}

export let setColor = (gui, colorObj, label) => {
  var ColorProxy = function () {
      this[label] = '#' + colorObj.getHexString()
  }
  var conf = new ColorProxy()
  gui.addColor(conf, label).onChange(() => {
    colorObj.set(conf[label])
  })
}

export let setNum = (gui, obj, key, label, min, max, step, onChange = () => {}) => {
  var ItemProxy = function(){
      this[label] = obj[key]
  }
  var conf = new ItemProxy()
  gui.add(conf, label, min, max, step).onChange(() => {
    obj[key] = Number((conf[label]))
    onChange(Number((conf[label])))
  })
}

export let setBtn = (gui, label, action) => {
  var BtnProxy = function () {
    this[label] = () => {
      action()
    }
  }
  var conf = new BtnProxy()
  gui.add(conf, label)
}
